import type { ExerciceVue } from "../api/client";

export function SelecteurDExercice({
  exercices,
  exercice,
  surChoix,
}: {
  exercices: ExerciceVue[] | undefined;
  exercice: ExerciceVue | undefined;
  surChoix: (id: string) => void;
}) {
  return (
    <select
      value={exercice?.id ?? ""}
      onChange={(evenement) => surChoix(evenement.target.value)}
      aria-label="Exercice"
      disabled={exercices == null || exercices.length === 0}
    >
      {(exercices ?? []).map((e) => (
        <option key={e.id} value={e.id}>
          Exercice {e.libelle} · {e.statutLibelle}
        </option>
      ))}
    </select>
  );
}
